<template>
    <div class="vertical-container">
        <div class="vertical-container__header vertical-container__header--has-shadow">
            <div class="container">
                <h1>Odběratelé</h1>
            </div>
        </div>

        <div class="vertical-container__content">
            <elementary-section>
                <div class="container">
                    <newsletter-container/>
                </div>
            </elementary-section>
        </div>
    </div>
</template>

<script>
import NewsletterContainer
    from '@/modules/ProjectModule/modules/CustomerModule/components/Newsletter/NewsletterContainer';
import ElementarySection from '@/components/Content/ElementarySection';

export default {
    components: {ElementarySection, NewsletterContainer},
    beforeMount() {
        this.$store.dispatch('projects/project/customer/newsletter/loadNewsletters');
    }
}
</script>
